import Blue from "~/core";

new Blue({
  name: "da-tabs",
  selector: "[data-tabpanels]",
  setup(tabsWrapper) {
    const tabs = Array.from(tabsWrapper.querySelectorAll("[role='tab']"));
    const panels = tabs.map(t => document.getElementById(t.getAttribute("aria-controls")));
    let current = tabs.findIndex(t => t.getAttribute("aria-selected") === "true");

    initEventListeners();
    select(current, false);


    // Functions
    function select(selectIndex, focus = true) {
      tabs.forEach((tab, index) => {
        const sel = index === selectIndex;
        const panel = panels[index];

        tab.setAttribute("aria-selected", sel ? "true" : "false");
        tab.tabIndex = sel ? 0 : -1;

        if (sel && focus) 
          tab.focus();

        if (panel) {
          panel.toggleAttribute("hidden", !sel);
          panel.tabIndex = sel ? 0 : -1;
        }
      });

      current = selectIndex;
    }

    function initEventListeners() {
      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => select(index, true));
      });

      tabsWrapper.addEventListener("keydown", e => {
        const k = e.key;
        let idx = current;

        if (k === "ArrowRight" || k === "ArrowDown") 
          idx = (current + 1) % tabs.length; 
        else if (k === "ArrowLeft" || k === "ArrowUp") 
          idx = (current - 1 + tabs.length) % tabs.length; 
        else if (k === "Home") 
          idx = 0; 
        else if (k === "End") 
          idx = tabs.length - 1; 
        else if (k === "Enter" || k === " ") { 
          select(current, true); 
          e.preventDefault(); 
          return; 
        } 
        else 
          return;

        e.preventDefault();
        select(idx, true);
      });
    }
  }
});